import { BaseEntity } from 'src/app/entity/base-entity';
import { AddressDto } from 'src/app/entity/addressDto';
import { LicenceTableDto } from 'src/app/entity/licenceTableDto';

export class CustomerDetailDto extends BaseEntity {
  name: string;
  address: AddressDto;

  licences: LicenceTableDto[];
}
